export function shouldShowAdminSidebarSection(params: {
  organizationRole: OrganizationRole;
  isSuperAdmin: boolean;
}): boolean {
  const { organizationRole, isSuperAdmin } = params;

  return organizationRole === 'admin' || (
    isSuperAdmin && organizationRole === 'super_admin'
  );
}

export function shouldShowAdminSidebarDashboard(params: {
  isSuperAdmin: boolean;
}): boolean {
  const { isSuperAdmin } = params;

  return isSuperAdmin;
}

export function shouldShowAdminDashboardReturnButton(params: {
  organizationRole: OrganizationRole;
  isSuperAdmin: boolean;
}): boolean {
  const { organizationRole, isSuperAdmin } = params;

  return isSuperAdmin && (
    organizationRole === 'user' ||
    organizationRole === 'admin' ||
    organizationRole === 'super_admin'
  );
}
